import {
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

import {
  getFinOpsDashboardSuccessful,
  getFinOpsDashboardFailure,
} from "./finOpsSlice";

import {
  getFinOpsDashboard as getFinOpsDashboardApi,
} from "../../helpers/auth_aws_helper";


function* getFinOpsDashboard({ payload }) {
  try {
    // Extract orgCode and accountNumber from payload
    // On first load, payload will be empty/undefined, so we don't send any params
    const orgCode = payload?.orgCode || null;
    const accountNumber = payload?.accountNumber || null;
    
    console.log("about to call *getFinOpsDashboard() with orgCode:", orgCode, "accountNumber:", accountNumber);
    const response = yield call(getFinOpsDashboardApi, orgCode, accountNumber);
    console.log("*getFinOpsDashboardApi() response: ", response);

    if (response && response.status === 200) {
      yield put(getFinOpsDashboardSuccessful(response));
    } else {
      let message = "An error occurred while fetching FinOps dashboard data";
      if (response.message) {
        message = response.message;
      } else if (response.data) {
        message = typeof response.data === 'string' ? response.data : response.data.message || response.data.error || JSON.stringify(response.data);
      }
      yield put(getFinOpsDashboardFailure({ message }));
    }
  } catch (error) {
    console.error("Error in getFinOpsDashboard saga:", error);
    let message = "An error occurred while fetching FinOps dashboard data";
    
    if (error.message) {
      message = error.message;
    } else if (error.response?.data) {
      message = typeof error.response.data === 'string' 
        ? error.response.data 
        : error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    }
    
    yield put(getFinOpsDashboardFailure({ message }));
  }
}

export function* watchFinOps() {
  yield takeLatest("finOps/getFinOpsDashboard", getFinOpsDashboard);
}

export function* finOpsSaga() {
  yield all([fork(watchFinOps)]);
}

export default finOpsSaga;

